export default __webpack_public_path__ + "static/media/purple-transform-logo-white.caed0cc2.png";